
import '@picocss/pico/css/pico.min.css';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'App',
});
